module.exports = __webpack_public_path__ + "static/media/page-11.9630e663.png";